/** @jsxImportSource @emotion/react */
import React, { useContext, useState } from 'react'
import { css, useTheme } from '@emotion/react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { ThemeUI } from '../../../theme'
import { Button, Card, Text } from '../../atoms'
import { ContentSection } from '../../organisms'
import * as styles from './index.styles'
import { Context } from "../../../context/ListItemsContext";
import { post_list_items } from '../../../redux/actions/list_items/post_list_items';
import { put_list_items } from '../../../redux/actions/list_items/put_list_items';
import { delete_list_items } from '../../../redux/actions/list_items/delete_list_items';
import Modal from '../Modal/index';


const AboutUsPreview: React.FC = () => {
  const dispatch = useDispatch()
  const theme = useTheme() as ThemeUI
  const navigate = useNavigate();
  const { formData } = useContext(Context)
  const token = useSelector((state: any) => state.login.access)
  let { id } = useParams();
  const [showModal, setShowModal] = useState<boolean>(false)
  const [showModalDelete, setShowModalDelete] = useState<boolean>(false)


  const handleChange = (token: any, formData: any) => {
    if (id) {
      if(formData.apply.length <= 1) {
        delete formData.apply 
      }
      if(formData.our.length <= 1) {
        delete formData.our 
      }
      if(formData.about.length <= 1) {
        delete formData.about 
      }
      dispatch(put_list_items({ id, token, data: formData, navigate }))
    } else {
      delete formData.id
      if (formData.about.length < 1) {
        delete formData.about
      }
      if (formData.our.length < 1) {
        delete formData.our
      }
      if (formData.apply.length < 1) {
        delete formData.apply
      }
      dispatch(post_list_items({ token, data: formData, navigate }))
    }
  }


  const handleDelete = () => {
    dispatch(delete_list_items({ id, token, data: formData, navigate }))
  }


  const successAction = () => {
    handleChange(token, formData)
  }

  const closeModal = () => {
    setShowModal(false)
  }

  const closeModalDelete = () => {
    setShowModalDelete(false)
  }


  return (
    <ContentSection
      style={styles.root}
      header={
        <Text textType='p' weight='bold'>Vista Previa</Text>
      }
    >
      <div css={(theme: any) => styles.preview(theme)}>
        <Card style={css({ overflow: 'hidden' })}>
          <Text textType='sm' style={styles.previewTitle(theme)}>
            {formData.title}
          </Text>
          <div css={styles.previewDescription(theme)}>
            <Text textType='sm' weight='light'>
              {formData.lang}
            </Text>
          </div>
        </Card>
      </div>
      <Button onClick={() => {
        setShowModal(true)
      }} disabled={!formData.title || !formData.lang}>
        {!id ? 'Publicar' : 'Guardar'} Elemento
      </Button>

      {
        id ?
          (
            <Modal
              show={showModal}
              title={'¿Esta seguro de modificar este elemento?'}
              text={' '}
              onClickSuccess={successAction}
              onClickClose={closeModal}
              btnSuccess={'Si'}
              btnWarning={"No"}
              onClickWarning={closeModal} />
          ) :
          (
            <Modal
              show={showModal}
              title={'¿Esta seguro de publicar este elemento?'}
              text={''}
              onClickSuccess={successAction}
              onClickClose={closeModal}
              btnSuccess={'Si'}
              btnWarning={"No"}
              onClickWarning={closeModal}
            />
          )
      }


      {id && (
        <>
          <Button onClick={() => {
            setShowModalDelete(true)
          }}>
            Eliminar Elemento
          </Button>
          <Modal
            show={showModalDelete}
            title={'¿Esta seguro de eliminar este elemento?'}
            text={' '}
            onClickSuccess={handleDelete}
            onClickClose={closeModalDelete}
            btnSuccess={'Si'}
            btnWarning={"No"}
            onClickWarning={closeModalDelete}
          />
        </>
      )}
    </ContentSection>
  )
}


export default AboutUsPreview;
